export default () => window.isMobileApp || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



// WEBPACK FOOTER //
// ./client/app/common/utils/isMobile.js